import SVG from "svg.js";

import Part from "@/components/body/parts/part";
import { BodyConfig } from ".";
import { Store } from "vuex";
import { Patient } from "@/store/modules/patient/types";

import { Colors } from "@/components/shared/util";

export default class Ulcer extends Part {
  ulcerIconFill!: SVG.Element;

  constructor(config: BodyConfig, container: SVG.Container, store: Store<any>) {
    super(config, container, store);
  }

  updateData(patient: Patient | null) {
    super.updateData(patient);
    if (!patient || !this.atom || !this.atom.value) {
      this.svgGroup.hide();
      return;
    }

    if (!this.ulcerIconFill) {
      this.ulcerIconFill = SVG.select(
        "#ulcerIconFill",
        this.container.node
      ).first();
    }

    const color = this.atom.value > 2 ? Colors.Red : Colors.Yellow;
    this.ulcerIconFill.attr({
      fill: color
    });
  }
}
